import EnterpriseComponent from "../EnterpriseComponent";
import {V1UserEmailToArray} from "../../../util/Payload";
import AxiosRestAPI from "../../../util/AxiosRestAPI";

class UserEmailEnterpriseComponent extends EnterpriseComponent {
    performQuery = (start, pageSize, foreignKey) => {
        let options = {
            method: "GET",
            url: "t6/v1/check_user_email",
            json: true,
            params: {
                "Email": this.getAttributeValue("Email"),
            },
        };
        this.notifyLoadStartListeners();
        AxiosRestAPI(options)
            .then(response => {
                this.fetchEnterpriseComponentSuccess(V1UserEmailToArray(response.data), start, pageSize);
            })
            .catch(error => {
                this.fetchEnterpriseComponentFailed(error);
            });
    };
}

export default UserEmailEnterpriseComponent